import { createStore } from 'vuex'

export default createStore({
  state: {
    darkMode: false,
  },
  mutations: {
    setDarkMode(state){
      state.darkMode = !state.darkMode
    }
  },
  actions: {

  }
})